export enum TimeInForce {
   Unknown = 0,
   Day = 1,
   GTC = 2,
}
